import Vue from 'vue';
import {
 chttp, apis, utils, storekeys,
} from '@/libs/interfaces';
import get from 'lodash/get'
import { vipExperienceToast } from '@/libs/app/config/payment';
import store from '@/store'

export default {
  // 显示1分钟体验会员挽留弹窗
  showExperienceDialog($this) {
    // 参数校验
    let openid = get($this, 'openid', '')
    let unionid = get($this, 'unionid', '')
    if (openid.length != unionid.length || openid.length != 28 || typeof $this.hasFreeVipM !== 'boolean' || typeof $this.isFreeVipM !== 'boolean') {
      // console.log(`openid: ${openid}, unionid: ${unionid}, hasFreeVipM: ${$this.hasFreeVipM}, isFreeVipM: ${$this.isFreeVipM}`)
      console.error('showExperienceDialog params is faild.')
      return
    }
    if ($this.hasFreeVipM !== true) {
      // console.log(`hasFreeVipM: ${$this.hasFreeVipM}, isFreeVipM: ${$this.isFreeVipM}`)
      console.log('no experience rights.')
      return
    }
    // 当天只弹1次
    if (utils.cookie.getCookie(storekeys.vip_experience_60s)) {
      console.log('once a day.')
      return
    }

    Vue.$sendLog({
      event_type: 'show',
      event_name: '领取弹窗',
      event_data: {
        name: '1分钟免费会员',
      },
    });
    Vue.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20220818/other/e0ef2ded26e97b62102c5208914ee22f.png', '', {
      tipsMessage: '领取成功!',
      clickButtonConfig: {
        img: 'https://qncweb-back1.ktvsky.com/20220818/other/c0e0faa4367ca0293ce01438c02f188b.png',
        width: '61.33vw',
        top: '82.66vw',
        animateName: 'breath',
        handlerButtonClick: () => {
          // 领取免费 VIP https://m2miovoqda.feishu.cn/wiki/wikcnNJitiT2RdY9yTXNc4STyub
          // 1.发送领取API
          const params = {
            openid: $this.openid,
            unionid: $this.unionid,
          }
          chttp.get(apis.experienceVIP, { params }).then((resource) => {
            if (resource && resource.errcode == 200) {
              // 更新VIP状态
              store.commit('SAVE_IS_VIP');
              // 2.暂存领取时间戳
              // this.$store2.set(utils.storekeys.vip_experience_60s, Date.now())
              // 明早凌晨时间戳
              const tomorrowTimeStamp = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
              // 当前剩余秒数
              const duration = parseInt((tomorrowTimeStamp - Date.now()) / 1000, 10)
              // 该 cookie 将在凌晨自动销毁，新的一天该活动自动刷新
              utils.cookie.setCookie2(Date.now(), duration, storekeys.vip_experience_60s)
              // 3.定时器
              setTimeout(() => {
                // 失效时间戳
                utils.cookie.setCookie2(-1, duration - 60, storekeys.vip_experience_60s)
                $this.$RaiseNewPayment({
                  ...vipExperienceToast,
                  event: $this,
                })
              }, 60 * 1000)
            }
          })
        },
      },
      handEffectConfig: {
        img: 'https://qncweb-back1.ktvsky.com/20220818/other/9f00502bfc1234a0b29d6f097f691652.png',
        width: '17.329vw',
        top: '85.33vw',
        left: '75.99vw',
        animateName: 'shake',
      },
      callback: () => {
        Vue.$sendLog({
          event_type: 'click',
          event_name: '领取弹窗',
          event_data: {
            name: '1分钟免费会员',
          },
        });
        Vue.$toast('领取成功!');
      },
      closeCallback: () => {
        Vue.$sendLog({
          event_type: 'click',
          event_name: '关闭领取弹窗',
          event_data: {
            name: '1分钟免费会员',
          },
        });
        // 明早凌晨时间戳
        const tomorrowTimeStamp = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
        // 当前剩余秒数
        const duration = parseInt((tomorrowTimeStamp - Date.now()) / 1000, 10)
        utils.cookie.setCookie2(-1, duration - 60, storekeys.vip_experience_60s)
      },
      restStyle: {
        img: {
          width: '85.6vw',
        },
      },
      entrance: '',
    });
  },
}
